export default "__VITE_ASSET__82247d49__"